import React from "react";

type Props = {
    name?: string;
    phone?: string | number;
    refId?: string | number;
    email?: string;
};

function CustomerCard({ name, phone, refId, email }: Props) {
    const initials = name
        ? name
            .split(" ")
            .map((w) => w[0])
            .slice(0, 2)
            .join("")
            .toUpperCase()
        : "—";

    return (
        <div className="bg-white border border-slate-200 rounded-xl p-4">
            <p className="text-[11px] text-slate-400 uppercase tracking-widest mb-3">
                Customer
            </p>
            <div className="flex items-center gap-3">
                {/* Avatar */}
                <div className="w-10 h-10 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-sm font-semibold shrink-0">
                    {initials}
                </div>
                {/* Info */}
                <div className="min-w-0">
                    <p className="text-sm font-semibold text-slate-800 truncate">
                        {name || "—"}
                    </p>
                    <p className="text-xs text-slate-500 mt-0.5">{phone || "—"}</p>
                    <p className="text-[11px] text-slate-400 mt-0.5">ID: {refId || "—"}</p>
                    {email && (
                        <p className="text-[11px] text-slate-400 mt-0.5 truncate">
                            {email}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default CustomerCard;